
import { Component, Prop, Vue } from "nuxt-property-decorator";

@Component
export default class TheText extends Vue {
  @Prop() query!: any;
  @Prop() genre!: string;
}
